import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ff744d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { id: "photo" }
const _hoisted_3 = {
  id: "photo-text",
  ref: "text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "filter" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MatrixText = _resolveComponent("MatrixText")!
  const _component_Office = _resolveComponent("Office")!
  const _component_Block = _resolveComponent("Block")!
  const _component_Service = _resolveComponent("Service")!
  const _component_Infos = _resolveComponent("Infos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MatrixText, { text: "Fondé par Sofia et Victor, SV Physio est un cabinet de physiothérapie spécialisé en pédiatrie et adulte, dans le domaine musculo-squelettique." })
      ], 512),
      _hoisted_4
    ]),
    _createVNode(_component_Block, {
      class: "block",
      id: "cabinet",
      "background-color": "var(--secondary-color)",
      "text-color": "var(--primary-color)"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Office)
      ]),
      _: 1
    }),
    _createVNode(_component_Block, { class: "block" }, {
      default: _withCtx(() => [
        _createVNode(_component_Service)
      ]),
      _: 1
    }),
    _createVNode(_component_Block, {
      class: "block",
      "background-color": "var(--primary-color)",
      "text-color": "var(--secondary-color-light)"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Infos)
      ]),
      _: 1
    })
  ]))
}